import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "burger",
  "use": "burger-usage",
  "viewBox": "0 0 25 18",
  "content": "<symbol viewBox=\"0 0 25 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"burger\">\n<rect x=\"0.158447\" width=\"24\" height=\"4\" fill=\"#26A69A\" />\n<rect x=\"0.158447\" y=\"7\" width=\"24\" height=\"4\" fill=\"#26A69A\" />\n<rect x=\"0.158447\" y=\"14\" width=\"24\" height=\"4\" fill=\"#26A69A\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/sharedComponents/Icon/images/burger.svg
// module id = FXP/
// module chunks = 13